import React from 'react';
import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Page Exercice Badminton (scaffold minimal)
 * Ajoute ici les exercices, ou remplace par ton propre contenu.
 */
export default function Exercices() {
  const navigate = useNavigate();
  return (
    <Paper sx={{ p: 2, mt: 3 }}>
      <Typography variant="h6">Exercices Badminton</Typography>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Page d'exercices — à compléter (liste d'exos, filtres, démonstrations, etc.).
        </Typography>

        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
          <Button variant="contained" onClick={() => navigate('/apps/badminton')}>Retour</Button>
        </Box>
      </Box>
    </Paper>
  );
}